import { useState } from "react";
import FaqForm, { FaqFormProps } from "./FaqForm";
import PageHeader from "../-components/PageHeader";
import { RouteTypes } from "hooks/utils/util";
import Seo from "components/Seo";

export default function ConsoleFaqCreate({ type }: { type: RouteTypes }) {
    const initialForm = {
        category: type,
        name: "",
        subject: "",
        contents: "",
        notice: 0,
        b_file: "",
        list_no: null,
    };
    const [form, setForm] = useState<FaqFormProps>(initialForm);

    return (
        <>
            <Seo type="console" pageTitle="FAQ" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="사이트관리" title="FAQ" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                            <FaqForm type={type} form={form} setForm={setForm} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
